<template>
    <b-overlay :show="tableLoading" rounded="sm" >
        <b-card class="inner-block item-type-list">
            <b-card-header>
                <b-row class="mt-2">
                    <!-- <b-col cols="3" md="1" class="d-flex align-items-center justify-content-center"><strong v-html="title"></strong></b-col> -->
                    <!-- <b-col cols="9" md="11"> -->
                    <b-col cols="12" class="d-flex">
                        <b-input id="search-item-type-input" v-model="filter" type="text" :placeholder="$translate('search_item_type')"></b-input>
                        <slot></slot>
                    </b-col>
                </b-row>
            </b-card-header>
            <b-card-body>
                <p class="mt-3">
                    <strong>
                        {{ $translate('page') }}: {{ currentPage }} {{ $translate('of') }}
                        {{ Math.ceil(rows / itemsPerPage) }} {{ $translate('total') }}:
                        {{ rows }}
                    </strong>
                </p>

                <b-table :fields="fields" responsive :items="items" :per-page="itemsPerPage" :current-page="currentPage"
                    :filter="filter">
                    <template #cell(id)="row">
                        <b-button :id="'view-item-type-'+row.item.id" v-if="hasPermissionView" @click="$emit('show-item', row.item.id)" class="mr-2"
                            variant="pink-button">
                            <img src="@/assets/images/icon/view.svg" />
                        </b-button>
                    </template>
                </b-table>

                <b-row>
                    <b-col>
                        <b-pagination class="justify-content-center mt-4" v-model="currentPage" :total-rows="rows"
                            :per-page="itemsPerPage" aria-controls="roleTable" :prev-text="$translate('previous')"
                            :next-text="$translate('next')" pills align="center"></b-pagination>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>
    </b-overlay>
</template>
<script>
import _ from 'lodash'

import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'ItemTypes-ListItems',
    props: ['type', 'items', 'title'],
    mixins: [popupMixins, permissionsMixins],
    data() {
        return {
            filter: '',
            itemsPerPage: 15,
            currentPage: 1,
            tableLoading: false,
        }
    },
    watch: {
      
        filter : {
            handler: async function () {
                await this.$store.dispatch('itemType/set_filter',this.filter)
            },
            deep: true,
        }
    },
    mounted() {
        this.tableLoading = true;
        setTimeout(() => {
        this.tableLoading = false;
        }, 2000);
     },

    methods: {
        truncate(text, length) {
            return _.truncate(text, { length: length })
        },
    },

    computed: {
        fields() {
            return [
                { key: 'id', label: this.$translate('actions') },
                { key: 'name', label: this.$translate('name') },
                { key: 'description', label: this.$translate('description') },
                {
                    key: 'group',
                    label: this.$translate('group'),
                    formatter: value => (value && value.name ? value.name : '')

                },
                { key: 'tax_rate', label: this.$translate('tax_rate') },
                { key: 'uom', label: this.$translate('uom') },
                { key: 'size_uom', label: this.$translate('size_uom') },
                {
                    key: 'is_task',
                    label: this.$translate('is_task'),
                    formatter: value => (value ? 'Yes' : 'No'),
                },

                {
                    key: 'is_order_item',
                    label: this.$translate('is_order_item'),
                    formatter: value => (value ? 'Yes' : 'No'),
                },

                {
                    key: 'is_discount',
                    label: this.$translate('is_discount'),
                    formatter: value => (value ? 'Yes' : 'No'),
                },
            ]
        },
        user() {
            return this.$store.state.user
        },

        // rows() {
        //     return this.items.length
        // },

        filteredItems() {
        if (!this.filter) {
            return this.items; // If no filter is applied, return all items
        }
        // Filter items based on the name or other properties (you can adjust this as needed)
        return this.items.filter(item =>
            item.name.toLowerCase().includes(this.filter.toLowerCase()) ||
            (item.description && item.description.toLowerCase().includes(this.filter.toLowerCase()))
        );
        },
    // Compute the number of rows based on the filtered items
        rows() {
            return this.filteredItems.length; // Return the length of the filtered items
        },
    },
}
</script>
<style></style>
